import { render, staticRenderFns } from "./cashier.vue?vue&type=template&id=184e6bd8&scoped=true&"
import script from "./cashier.vue?vue&type=script&lang=ts&"
export * from "./cashier.vue?vue&type=script&lang=ts&"
import style0 from "./cashier.vue?vue&type=style&index=0&id=184e6bd8&prod&lang=scss&scoped=true&"
import style1 from "./cashier.vue?vue&type=style&index=1&id=184e6bd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184e6bd8",
  null
  
)

export default component.exports